import React from 'react'
import './hr.scss'

export default function HR() {

    return <div className='hr' />

}